export default __webpack_public_path__ + "static/media/Markers_Dark Blue Marker - Boat.3505ed5f.svg";